import { render, staticRenderFns } from "./NavigationText.vue?vue&type=template&id=94c02c88&scoped=true"
import script from "./NavigationText.vue?vue&type=script&lang=js"
export * from "./NavigationText.vue?vue&type=script&lang=js"
import style0 from "./NavigationText.vue?vue&type=style&index=0&id=94c02c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c02c88",
  null
  
)

export default component.exports